import styled from 'styled-components';
import { Button, Link } from './core';
import { Modal, ModalContent, ModalFooter, ModalHeader } from './Modal';
import { resetCookieConsentValue } from 'react-cookie-consent';

const Paragraph = styled.p`
  margin: 0;
  margin-block-start: 0;
  margin-block-end: 0;
`;

export interface PrivacyModalProps {
  onClose(): void;
  isOpen: boolean;
}

export function PrivacyModal({ onClose, isOpen }: PrivacyModalProps) {
  function handleResetConsent() {
    resetCookieConsentValue('analytics_consent');
    window.location.reload();
  }

  return (
    <Modal scrollable onClose={onClose} isOpen={isOpen}>
      <ModalHeader>Privacy policy</ModalHeader>
      <ModalContent scrollable>
        <Paragraph>
          We at lovemedoku.com store minimal data in your browser's localStorage
          to save your progress for the day. This data stays entirely on your
          device and is automatically reset daily. By playing, you agree to this
          local storage being used solely to maintain your game state.
        </Paragraph>
        <br />
        <Paragraph>
          We also use Google Analytics to collect data. We need this data to
          understand how you use our website so we can improve its design and
          functionality. With your consent, Google Analytics will process and
          collect your personal data (cookies and IP address) to give us
          valuable information. Google Analytics will transfer your data to the
          United States and store it for 6 months. To learn more about Google's
          data transfer policies,{' '}
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.google.com/policies/privacy/partners/"
          >
            click here
          </Link>
          . You have certain rights over your data: for example, you can require
          us to delete them or to provide you with a copy. We take
          responsibility for the processing of your data. We are available to
          answer any question and handle any request from you. Go to the "Give
          us feedback" link in the footer of the site if you have any queries,
          concerns or requests.
        </Paragraph>
        <br />
        <Paragraph>
          You can reset your consent at any time by pressing the "Reset consent"
          button below
        </Paragraph>
      </ModalContent>
      <ModalFooter>
        <Button onClick={handleResetConsent}>Reset consent</Button>
        <Button onClick={onClose}>Close</Button>
      </ModalFooter>
    </Modal>
  );
}
